import React from "react";
import { Navigate } from "react-router-dom";

const ModuleProtectedRoute = ({ children, moduleName }) => {
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  const allowedModules = JSON.parse(
    localStorage.getItem("allowedModules") || "[]",
  );

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  if (!allowedModules.includes(moduleName)) {
    return <Navigate to="/DashBoard" replace />;
  }

  return children;
};

export default ModuleProtectedRoute;
